import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactApexChart from 'react-apexcharts';
import { printCurrencyTooltip, printNumber } from '../../../utils/helper';
import useRequest from '../../../hooks/useRequest';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';

const UsersByLogin = ({ startDate, endDate }) => {
  const [users, setUsers] = useState([]);
  const [chartLabels, setChartLabels] = useState([]);
  const [donutChartSeries, setDonutChartSeries] = useState([]);
  const [getUsersPercentageByLoginMethodRequest, { loading: getUsersPercentageByLoginMethodLoading }] = useRequest({
    url: '/patient-tracking/admin-tools/app-login-method-percentage',
    method: 'POST',
    onSuccess: (data) => {
      setUsers([
        {
          loginType: 'Google',
          percentage: data?.results[0]?.google_percent,
        },
        {
          loginType: 'Apple',
          percentage: data?.results[0]?.apple_percent,
        },
        {
          loginType: 'Web',
          percentage: data?.results[0]?.web_percent,
        },
      ]);
    },
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });

  useEffect(() => {
    getUsersPercentageByLoginMethodRequest({
      body: {
        startDate,
        endDate,
      },
    });
  }, [startDate, endDate]);

  useEffect(() => {
    setChartLabels(users.map((e) => e.loginType));
    setDonutChartSeries(users.map((e) => parseFloat(e.percentage)));
  }, [users]);

  const donutChartOptions = {
    chart: {
      type: 'pie',
    },
    legend: {
      position: 'bottom',
    },
    colors: ['#278EFD', '#A5D0FF', '#D8EBFF'],
    labels: chartLabels,
    dataLabels: {
      style: {
        fontSize: '15px',
      },
      dropShadow: {
        enabled: false,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            value: {
              fontSize: '12px',
              fontWeight: 600,
              offsetY: 0,
            },
          },
        },
      },
    },
    tooltip: {
      y: printCurrencyTooltip(),
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          legend: {
            position: 'bottom',
            fontSize: 14,
            horizontalAlign: 'center',
          },
          chart: {
            height: 280,
          },
        },
      },
      {
        breakpoint: 1400,
        options: {
          legend: {
            position: 'top',
            fontSize: 10,
            offsetX: -70,
          },
          chart: {
            height: 200,
          },
        },
      },
      {
        breakpoint: 1600,
        options: {
          legend: {
            position: 'bottom',
            fontSize: 11,
            horizontalAlign: 'center',
            offsetX: -30,
          },
          chart: {
            height: 240,
          },
        },
      },
    ],
  };

  return (
    <>
      <Loader isActive={getUsersPercentageByLoginMethodLoading} />
      <Card>
        <CardBody>
          <CardTitle className="mb-4">% Users By Login</CardTitle>
          <div className="d-flex flex-wrap justify-content-between mt-4 total-by-gender">
            {users?.map((e, i) => {
              return (
                <div className="pe-md-1 mb-md-2 mb-3" key={i}>
                  <div className="widget-metric">
                    <h6 className="widget-metric-title">{e.loginType}</h6>
                    <h3 className="widget-metric-value">{e?.percentage}%</h3>
                  </div>
                </div>
              );
            })}
          </div>
          <ReactApexChart options={donutChartOptions} series={donutChartSeries} type="pie" width={600} height={400} />
        </CardBody>
      </Card>
    </>
  );
};

export default UsersByLogin;
